import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './DailyNote.scss';

const initSize = () => {
  const width = window.innerWidth;
  if (width > 1680) {
    return 'large';
  }
  if (width < 1200) {
    return 'small';
  }
  return 'normal';
};

const isClose = () => {
  const date = localStorage.getItem('close_daily_banner');
  if (!date) {
    return false;
  }
  return new Date() < Number(date);
};

export default class DailyNote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      size: initSize(),
      width: window.innerWidth * 0.16666667,
      close: isClose(),
    };
  }
  componentDidMount() {
    window.addEventListener('resize', this.setWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setWidth);
  }

  setWidth = () => {
    const width = this.daily.clientWidth;
    if (width > 280) {
      this.setState({
        size: 'large',
        width,
      });
      return;
    }
    if (width < 200) {
      this.setState({
        size: 'small',
        width,
      });
      return;
    }
    this.setState({
      size: 'normal',
      width,
    });
  }

  toDailyNote = () => {
    window.open('https://www.jianshu.com/mobile/campaign/day_by_day/join?from=editor');
  }

  handleClose = (e) => {
    e.stopPropagation();
    localStorage.setItem('close_daily_banner', new Date().valueOf() + 1296000000);
    this.setState({
      close: true,
    });
  }

  render() {
    const { size, width, close } = this.state;

    if (close) {
      return null;
    }

    return (
      <div
        ref={(el) => { this.daily = el; }}
        className={classNames(styles[`daily-note-${size}`], styles['daily-note'])}
      >
        <div
          className={styles['daily-note-fixed']}
          onClick={this.toDailyNote}
          style={{ width: `${width}px` }}
        >
          <div className={styles['daily-note-banner']}>
            <i onClick={this.handleClose}/>
          </div>
        </div>
        <div className={styles['placeholder']}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DailyNote/DailyNote.js